export default __webpack_public_path__ + "static/media/one-drive.60e823be.svg";